import React, { useState } from 'react';
import LocationsContext from '../context/locations.Context';
import { fromJS } from 'immutable';

const LocationsContextProvider = ({ children }) => {

    /**
     * Locations + Device data / controls
     */
    const clearLocationsData = (() => {
        updateLocations(initialLocationsState);
    });

    const setLocations = ({
        newLocations
    }) => {
        updateLocations(prevState => {
            const newLocationsState = {
                ...prevState, locations: newLocations
            };
            return newLocationsState;
        });
    };

    const setActiveLocationId = (activeLocationId) => {
        updateLocations(prevState => {
            const newLocationsState = {
                ...prevState, activeLocationId: activeLocationId
            };
            return newLocationsState;
        });

    };

    const setActiveGroupId = (locationId, activeGroupId) => {

        // activeGroupIds contains a map of location ID / Group ID

        updateLocations(prevState => {

            var newActiveGroupIds;

            if (prevState.activeGroupIds) {
                const immGroupIds = fromJS(prevState.activeGroupIds);
                const newGroupIds = immGroupIds.setIn([prevState.activeLocationId.toString(), 'groupId'], activeGroupId);
                newActiveGroupIds = newGroupIds.toJS();
            }
            else
                newActiveGroupIds = { [prevState.activeLocationId.toString()]: { groupId: activeGroupId } };

            const newLocationsState = {
                ...prevState, activeGroupIds: newActiveGroupIds
            };
            return newLocationsState;
        });

    };

    const setDeviceState = (locationId, device) => {

        // Update the device state (lastState, lastLevel, lastTemperature, lastKnownIP)

        updateLocations(prevState => {

            if (prevState.locations) {
                const immLocations = fromJS(prevState.locations);
                const newLocations = immLocations.setIn([locationId.toString(), 'devices', device.id], device);

                const newLocationsState = {
                    ...prevState, locations: newLocations.toJS()
                };
                return newLocationsState;
            }
            else
                return prevState;
        });

    };

    const setGroupDevices = (locationId, groupId, deviceIds) => {

        updateLocations(prevState => {
            if (prevState.locations) {
                const immLocations = fromJS(prevState.locations);
                const newLocations = immLocations.setIn([locationId.toString(), 'groups', groupId.toString(), 'deviceIDs'], deviceIds);

                const newLocationsState = {
                    ...prevState, locations: newLocations.toJS()
                };
                return newLocationsState;
            }
            else
                return prevState;

        });
    };

    const setDevices = (locationId, newDevices) => {
        updateLocations(prevState => {
            if (prevState.locations) {
                const immLocations = fromJS(prevState.locations);
                const newLocations = immLocations.setIn([locationId.toString(), 'devices'], newDevices);

                const newLocationsState = {
                    ...prevState, locations: newLocations.toJS()
                };
                return newLocationsState;
            }
            else
                return prevState;
        });
    };

    const setGroup = (locationId, group) => {
        updateLocations(prevState => {
            if (prevState.locations) {
                // Add, update or delete group?
                if (prevState.locations[locationId].groups[group.id.toString()]) {
                    if (group.name === '') {
                        // Delete group
                        let { [group.id.toString()]: _, ...groups } = prevState.locations[locationId].groups;

                        return {
                            ...prevState,
                            locations: {
                                ...prevState.locations, [locationId]: {
                                    ...prevState.locations[locationId], groups: groups
                                }
                            }
                        };
                    }
                    else {
                        // Update group
                        return {
                            ...prevState,
                            locations: {
                                ...prevState.locations, [locationId]: {
                                    ...prevState.locations[locationId], groups: {
                                        ...prevState.locations[locationId].groups, [group.id]: {
                                            ...prevState.locations[locationId].groups[group.id], name:
                                                group.name
                                        }
                                    }
                                }
                            }
                        };
                    }
                }
                else {
                    // Add new group
                    return {
                        ...prevState,
                        locations: {
                            ...prevState.locations, [locationId]: {
                                ...prevState.locations[locationId], groups: {
                                    ...prevState.locations[locationId].groups, [group.id]: {
                                        id: [group.id], name: [group.name], devices: null, deviceIDs: []
                                    }
                                }
                            }
                        }
                    };
                }
            }
        });
    };



    const initialLocationsState = {
        locations: {
            location: {
                id: 0, name: 'Unknown', owner: '', authorization: '', groups: {}, users: {}
            }
        },
        activeLocationId: 0,
        activeGroupIds: { "0": { groupId: 0 } },
        clearLocationsData,
        setLocations,
        setActiveLocationId,
        setActiveGroupId,
        setDeviceState,
        setGroupDevices,
        setDevices,
        setGroup
    };

    function getInitialState() {
        var locationsStateLocalStorage;
        try {
            const fromLocalStorage = JSON.parse(localStorage.getItem('locationsData'));
            if (fromLocalStorage) {
                locationsStateLocalStorage = { ...fromLocalStorage, clearLocationsData, setLocations, setActiveLocationId, setActiveGroupId, setDeviceState, setGroupDevices, setDevices, setGroup };
            }
            return locationsStateLocalStorage || initialLocationsState;
        }
        catch (error) {
            return initialLocationsState;
        }

    }

    const [locations, updateLocations] = useState(getInitialState);

    React.useEffect(() => {
        localStorage.setItem('locationsData', JSON.stringify(locations));
    }, [locations]);



    return (
        <LocationsContext.Provider value={locations}>
            {children}
        </LocationsContext.Provider>
    );
};

export default LocationsContextProvider;


// WEBPACK FOOTER //
// ./src/components/LocationsContextProvider.js